// Utilidades compartidas: mensajes de error y formatos (es-CO / Bogotá).

export function errMsg(e, fallback = "Ocurrió un error.") {
  if (e?.response?.status === 429) {
    return "Demasiadas consultas, espere un momento.";
  }
  const d = e?.response?.data?.detail;
  if (typeof d === "string" && d.trim()) return d;
  if (Array.isArray(d)) {
    // Errores 422 de FastAPI: lista de {msg, loc, ...}
    const msgs = d
      .map((x) => (typeof x === "string" ? x : x?.msg))
      .filter(Boolean);
    if (msgs.length) return msgs.join(" · ");
  }
  return e?.message || fallback;
}

export const fmtMoney = (v) =>
  new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    maximumFractionDigits: 0,
  }).format(Number(v || 0));

/** Hoy en Bogotá como YYYY-MM-DD. */
export function bogotaToday() {
  return new Date().toLocaleDateString("en-CA", { timeZone: "America/Bogota" });
}

/** Suma días a una fecha YYYY-MM-DD (sin líos de zona horaria). */
export function addDaysISO(iso, days) {
  const [y, m, d] = iso.split("-").map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d, 12));
  dt.setUTCDate(dt.getUTCDate() + days);
  return dt.toISOString().slice(0, 10);
}

/** Fecha plana YYYY-MM-DD → "mié, 15 de jul de 2026" (sin corrimiento de zona). */
export function fmtDate(iso) {
  if (!iso) return "—";
  const s = String(iso).slice(0, 10);
  const [y, m, d] = s.split("-").map(Number);
  if (!y || !m || !d) return s;
  return new Date(Date.UTC(y, m - 1, d, 12)).toLocaleDateString("es-CO", {
    weekday: "short",
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: "UTC",
  });
}

/** Hora "HH:MM[:SS]" o ISO → "h:mm AM/PM". */
export function fmtHour(t) {
  if (!t) return "—";
  const s = String(t);
  if (s.includes("T")) {
    const hasTZ = /Z$|[+-]\d{2}:?\d{2}$/.test(s);
    if (hasTZ) {
      try {
        return new Date(s).toLocaleTimeString("es-CO", {
          timeZone: "America/Bogota",
          hour: "numeric",
          minute: "2-digit",
        });
      } catch {
        return "—";
      }
    }
    return fmtHour(s.split("T")[1]);
  }
  const m = s.match(/^(\d{1,2}):(\d{2})/);
  if (m) {
    let h = parseInt(m[1], 10);
    const ampm = h >= 12 ? "p. m." : "a. m.";
    h = h % 12 || 12;
    return `${h}:${m[2]} ${ampm}`;
  }
  return s;
}

/**
 * Fecha-hora → texto es-CO en hora de Bogotá.
 * Si el timestamp viene "naive" (sin zona), se asume hora de pared de Bogotá
 * y se formatea tal cual, sin convertir.
 */
export function fmtDateTime(iso) {
  if (!iso) return "—";
  const s = String(iso);
  if (!s.includes("T") && !s.includes(" ")) return fmtDate(s);
  const norm = s.replace(" ", "T");
  const hasTZ = /Z$|[+-]\d{2}:?\d{2}$/.test(norm);
  if (!hasTZ) {
    const [d, t] = norm.split("T");
    return `${fmtDate(d)}, ${fmtHour(t)}`;
  }
  try {
    return new Date(norm).toLocaleString("es-CO", {
      timeZone: "America/Bogota",
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
    });
  } catch {
    return s;
  }
}

// Estados del cupón → etiqueta y clase de chip.
export const RES_STATUS = {
  active: { label: "Activo", cls: "st-active" },
  redeemed: { label: "Redimido", cls: "st-redeemed" },
  expired: { label: "Vencido", cls: "st-expired" },
  cancelled: { label: "Cancelado", cls: "st-cancelled" },
};

// Disponibilidad → etiqueta y clase de chip.
export const AVAIL = {
  disponible: { label: "Disponible", cls: "av-ok" },
  pocos: { label: "Pocos cupos", cls: "av-warn" },
  lleno: { label: "Lleno", cls: "av-full" },
};

// Tipos de movimiento del libro del cupo.
export const MOV_TYPE = {
  saldo_inicial: "Saldo inicial",
  recarga: "Recarga",
  venta: "Venta",
  anulacion: "Anulación",
  ajuste: "Ajuste",
};
